module.exports = __webpack_public_path__ + "img/cordoba_spring.1e7e98d8.svg";